import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { GeneralService } from 'src/app/api/config/general.service';
import { PackagetourService } from 'src/app/api/tourism/packagetour.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-vehicletype-extends',
  templateUrl: './vehicletype-extends.component.html',
  styleUrls: ['./vehicletype-extends.component.css']
})
export class VehicletypeExtendsComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  item: FormGroup;
  submitted: boolean = false;

  constructor(
    public fb: FormBuilder,
    private generalService: GeneralService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.item = this.fb.group({
      description: [null, [Validators.required, Validators.minLength(2)]]
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  focused() {
    setTimeout(() => {
      (<any>$('#item_description_vehicketype')).focus();
    }, 500);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    this.LoadingModalComponent.show();
    this.generalService.saveVehicleType(this.item.value).subscribe({
      next: (data: any) => {
        this.alertifyMsg.success('Registro realizado con éxito');
        this.onSubmitEvent.emit(data.data);
        this.LoadingModalComponent.hide();
        (<any>$('#openExtendsVechicleType')).modal('hide');
        this.resetForm();
      }
    });
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
  }

  close() {
    this.item.reset();
  }
}